var _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0013 9C15.0013 8.44772 14.5536 8 14.0013 8C13.449 8 13.0013 8.44772 13.0013 9V13.0011H9C8.44771 13.0011 8 13.4488 8 14.0011C8 14.5534 8.44771 15.0011 9 15.0011H13.0013V19.0022C13.0013 19.5545 13.449 20.0022 14.0013 20.0022C14.5536 20.0022 15.0013 19.5545 15.0013 19.0022V15.0011H19.0022C19.5545 15.0011 20.0022 14.5534 20.0022 14.0011C20.0022 13.4488 19.5545 13.0011 19.0022 13.0011H15.0013V9Z",
    fill: "url(#paint0_linear_7323_17457)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "url(#paint1_linear_7323_17457)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7323_17457",
    x1: 12.8346,
    y1: 20.0022,
    x2: 15.1676,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7323_17457",
    x1: 11.2787,
    y1: 28,
    x2: 16.7213,
    y2: -1.65989e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/PlusButton.9e7a72299bd4341661100ce26026456d.svg";
export { ForwardRef as ReactComponent };